<template>
  <div class="help-header">
     <router-link :to="{ name: 'help' }">
      <div class="left">
        <img class="logo" src="../../assets/images/logo02.png" />
        <span class="driver">|</span>
        <span class="title">帮助中心</span>
      </div>
     </router-link>  

    <div class="searchBox" v-if="IsHome && showSearch">
      <Icon type="ios-search" size="16" color="#487AF7" class="ic_search" />
      <input
        v-model="searchData"
        class="searchinput"
        placeholder="从文档中搜寻答案"
        @keyup.enter="onSearch"
      />
      <Icon
        type="md-close"
        size="20"
        color="#000000"
        class="ic_close"
        @click="searchClose"
      />
    </div>
    <div>
      <Icon
        v-if="IsHome && !showSearch"
        type="ios-search"
        size="16"
        class="ic_search"
        @click="showSearch = true"
      />
      <span class="driver" v-if="IsHome">|</span>
      <router-link :to="{ name: 'home' }">
        <span class="uccn">前往后台</span>
      </router-link>
      <router-link :to="{ name: 'login' }" v-if="!userAvator">
        <span class="login">登录/注册</span>
      </router-link>
      <Dropdown @on-click="handleClick" v-else>
        <Avatar :src="userAvator" />
        <Icon :size="18" type="md-arrow-dropdown"></Icon>
        <DropdownMenu slot="list">
          <DropdownItem name="user_center">个人中心</DropdownItem>
          <DropdownItem name="logout">退出登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "help-header",
  props: {
    IsHome: { type: Boolean, default: false },
  },
  data() {
    return {
      showSearch: false,
      searchData: "",
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["HandleLogOut"]),
    handleClick(name) {
      switch (name) {
        case "logout":
          this.HandleLogOut().then(() => {
            this.$router.push({
              name: "login",
            });
          });
          break;
        case "user_center":
          this.$router.push({ name: "user_center" });
          break;
      }
    },
    //搜索
    onSearch() {
        this.$emit("searchData", this.searchData);
    },
    searchClose() {
      this.showSearch = false;
      this.searchData = "";
    },
    selectChange(e) {
      console.log("选中的：", e);
      this.$router.push({ name: "help_list" });
    },
  },
  computed: {
    ...mapGetters(["current_user"]),
    userAvator() {
      return this.current_user.avatar || this.avatar;
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
